import IndividualService from "./IndividualService";
export default IndividualService;